import type { Label } from "./VersionTab/types";

export interface VersionSelectorVersion {
  id: number | string;
  number: number;
  created_at: string;
  commit_message: string | null;
  author?: string | null;
  user_email?: string | null;
  labels: Label[];
  archived: boolean;
  report_id?: number | null;
  parent_version?: { id: number; number: number } | null;
}

export type VersionSelectorVersionId = VersionSelectorVersion["id"];

export const getVersionAuthor = (version: VersionSelectorVersion) =>
  "user_email" in version ? version.user_email : version.author;

export const getVersionCommitMessage = (version: VersionSelectorVersion) => version.commit_message;

export const getVersionLabels = (version: VersionSelectorVersion): Label[] => version.labels;

export const getVersionReportId = (version: VersionSelectorVersion) =>
  "report_id" in version ? version.report_id : null;
